export const sectionGridStyles = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' },
  gap: 2,
};

export const fieldColumnStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};
